import { useTranslation } from "react-i18next";
import { IconSearch } from "@tabler/icons-react";
import { debounce } from "lodash";

const Heading = ({ searchInput, onChangeSearchInput }) => {
  const { t: getLabel } = useTranslation();

  const handleChangeSearchInput = debounce(event => {
    onChangeSearchInput(event.target.value);
  }, 500);

  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div className="d-flex gap-2">
        <div className="input-group" style={{ width: 600 }}>
          <input
            type="text"
            className="form-control"
            placeholder={getLabel("P_SEARCH_APP")}
            onChange={handleChangeSearchInput}
            defaultValue={searchInput}
          />
          <span className="input-group-text">
            <IconSearch size={16} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Heading;
